import { reportsApi } from 'Api/axios/reports-api';
import useCoursesReportApi from 'Hooks/useCoursesReportApi';
import useTranslation from 'Hooks/useTranslation';
import { useState } from 'react';
import { toast } from 'sonner';
import type { CourseReportFilterI } from 'types';
import { downloadFile } from 'Utils/file-utils';

const useCoursesReportPage = () => {
  const { t2 } = useTranslation('courses_reports');
  const [currentFilters, setCurrentFilters] = useState<CourseReportFilterI>({});
  /**
   * Custom hook para obtener el reporte de los cursos.
   */
  const { data: coursesReportData, fetchCoursesReport } = useCoursesReportApi({ init: true });

  /**
   * Realiza una consulta a la API para obtener el reporte de los cursos. Támbien
   * considera los filtros si se aplican.
   */
  const onSearch = (filters: CourseReportFilterI) => {
    setCurrentFilters(filters);
    fetchCoursesReport(filters);
  };

  /**
   * Realiza una exportación de los datos que actualmente se muestran en la tabla.
   */
  const onExport = async () => {
    const response = await reportsApi.exportCourses(currentFilters);

    if (response.data) {
      downloadFile(response.data, `cursos_reporte.xlsx`);
      toast.success(t2('export_success'));
    }
  };

  return {
    t2,
    onSearch,
    coursesReportData,
    onExport,
  };
};

export default useCoursesReportPage;
